
<div class="card">
    <div *ngFor="let col of columns" >
        <div class="title-value">{{col.headerTranslate |translate}} </div>
        <div class="field-value" *ngIf="!col.type">{{currentPayment[col.field]}}</div>
        <div class="field-value" *ngIf="col.type==fieldTypes.date">{{currentPayment[col.field] | date:'dd/MM/yyyy'}}</div>
        <div class="field-value" *ngIf="col.type==fieldTypes.sumWithCurrency">{{currentPayment[col.field]| currency:currentPayment[col.currencyFieldName]:'symbol':'3.0'}}</div>
        <div class="field-value" *ngIf="col.type==fieldTypes.enumComboBox">{{currentPayment[col.field]| enumTranslate:col.enumType:col.enumName}}</div>
        <a *ngIf="currentPayment[col.isDisplay]" target="_blank" rel="noopener noreferrer" href="{{currentPayment[col.field]}}"> {{col.linkDescription|translate}}</a>
    </div>
</div>
